import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { parseMediaColumnValue } from '@/shared/data';
import { TooltipListItem } from '../TooltipListItem/TooltipListItem';

const Image = styled('img')(() => ({
  height: 16,
  width: 16,
  aspectRatio: '1 / 1',
  objectFit: 'contain',
}));

interface Props {
  pattern?: string;
  nameObject: string;
  value: number;
  color: string;
  valueFormatter: (v: number) => string;
}

export function TooltipMediaItem({
  pattern,
  color,
  nameObject,
  value,
  valueFormatter,
}: Props) {
  const parsedValue = parseMediaColumnValue(nameObject);

  return (
    <TooltipListItem
      label={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ color }}>
            {pattern} <Image src={parsedValue.url} /> {parsedValue.value}
          </span>
          :
        </Box>
      }
      value={valueFormatter(value)}
    />
  );
}
